import React, {Component} from "react"
import {RouteComponentProps} from "react-router"
import {Grid} from "react-bootstrap"

import wellnessService from "@irati/wellness/services/Wellness"
import {WellnessMedia, WellnessMediaType} from "@irati/types"
import {MarketingProfile, UpdateMarketingProfileInput} from "@irati/types/ops"
import Loading from "@irati/ui/src/Loading"
import Loader from "@irati/ui/src/Loading/Loader"
import marketingService from "@irati/marketing/services/marketing"
import authentication from "@irati/auth"

import SingleMedia from "./SingleMedia"
import CourseMedia from "./CourseMedia"

interface Match {
  mediaId: string
}

interface Props extends RouteComponentProps<Match> {
}

interface State {
  media?: WellnessMedia,
  load?: Promise<void>,
  marketingProfile?: MarketingProfile
}

class MediaDetail extends Component<Props, State> {
  state: State = {}

  componentDidMount() {
    const {mediaId} = this.props.match.params
    const load = Promise.all([
      wellnessService.getMediaById(mediaId, {fetchPolicy: "network-only"}),
      marketingService.getProfile({userId: authentication.user().uuid})
    ]).then(([media, marketingProfile]) => {
      this.setState({media, marketingProfile})
    })
    this.setState({load})
  }

  componentDidUpdate() {
    const {mediaId} = this.props.match.params
    const {media} = this.state
    if (media?.uuid !== mediaId) {
      wellnessService.getMediaById(mediaId).then((m) => {
        this.setState({media: m})
      })
    }
  }

  handleClick = (marketingProfileInput: UpdateMarketingProfileInput) => {
    marketingService.updateProfile(marketingProfileInput)
    this.setState({marketingProfile: marketingProfileInput})
  }

  render() {
    const {media, load, marketingProfile} = this.state

    const showSingleScreen = media?.type === WellnessMediaType.SingleVideo ||
      media?.type === WellnessMediaType.SingleAudio ||
      media?.type === WellnessMediaType.LiveVideo
    const showCourseScreen = media?.type === WellnessMediaType.VideoCourse || media?.type === WellnessMediaType.AudioCourse

    return (
      <Loading load={load}>
        {showCourseScreen && <CourseMedia media={media} />}
        {showSingleScreen && <SingleMedia media={media} marketingProfile={marketingProfile} handleClick={this.handleClick} />}

        {!showCourseScreen && !showSingleScreen && <Grid><Loader /></Grid>}
      </Loading>
    )
  }
}

export default MediaDetail
